/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Link_Jid_TakenInputs */

const he_account_delivery_link_jid_taken = /** @type {(inputs: Account_Delivery_Link_Jid_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר הווטסאפ הזה כבר מקושר לחשבון אחר.`)
};

const en_account_delivery_link_jid_taken = /** @type {(inputs: Account_Delivery_Link_Jid_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This WhatsApp number is already linked to another account.`)
};

/**
* | output |
* | --- |
* | "This WhatsApp number is already linked to another account." |
*
* @param {Account_Delivery_Link_Jid_TakenInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_link_jid_taken = /** @type {((inputs?: Account_Delivery_Link_Jid_TakenInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Link_Jid_TakenInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_link_jid_taken(inputs)
	return en_account_delivery_link_jid_taken(inputs)
});